// Selector to get the current theme from the state
import { StoreState } from "../types/StoreState";

const getDialogProps = (state: StoreState) => {
  return state.coreState.dialog;
};

export default getDialogProps;
